import { ink, focus } from "../../UI/tokens";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { v } from "../../../styles/variables";
import { Tooltip } from "react-bootstrap";

export const SDivContainer = styled.div`
  width: 100%; min-width: 0; margin: 0; border-radius: 9px;
  padding-left: ${({ quebra, $baropen }) => $baropen ? Math.min(Number(quebra) || 0, 3) * 12 : 0}px;
  color: ${ink}; cursor: pointer;
  &:hover { background: rgba(80,115,175,.09); }

`;

export const SLinkIconSub = styled.div`
  display: flex; align-items: center; flex: 0 0 16px; margin-left: auto;
  opacity: .55; svg { width: 16px; height: 16px; }

`;

export const SLink = styled(Link)`
    /* position: relative; */
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    font-size: 16px;
    padding: calc(${v.smSpacing} - 2px) 0;

min-height: 38px; font-size: 13px; line-height: 1.4; padding-top: 8px; padding-bottom: 8px; ${focus}
`;

export const SLinkSubnav = styled(Link)`
    position: relative;
    margin-left: 10px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    font-size: 16px;
    padding: calc(${v.smSpacing} - 2px) 0;

min-height: 38px; font-size: 13px; line-height: 1.4; padding-top: 8px; padding-bottom: 8px; ${focus}
`;

export const SLinkLabel = styled.span`
  flex: 1; min-width: 0; margin: 0;
  font-size: 13px; font-weight: 500; line-height: 1.45;
  white-space: normal; overflow-wrap: break-word;

`;

export const SLinkIcon = styled.div`
  display: flex; align-items: center; gap: 10px;
  width: 100%; min-height: 44px; padding: 10px 12px;
  & > svg { width: 19px; height: 19px; flex: 0 0 19px; opacity: .85; }

`;

export const SLinkNotification = styled.div`
    font-size: 14px;
    padding: calc(${v.smSpacing} / 2) ${v.smSpacing};
    border-radius: calc(${v.borderRadius} / 2);
    background: ${({ theme }) => theme.primary};
    color: white;
    margin-right: ${v.mdSpacing};

    :hover {
        background: ${({ theme }) => theme.primary};
    }

`;

export const ToolTipMenu = styled(Tooltip)`
    display: ${({ $baropen }) => ($baropen ? 'none' : 'block' ) };
`